import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer } from 'react-notifications'
import AdminLayout from "../../../components/AdminLayout"

import CardService from "../../../services/card_services"
import PackForm from "./PackForm"

class AdminCreatePack extends Component {
    handleSubmit = async (payload) => {
        return await CardService.createPack(payload)
    }

    render() {
        return (
            <>
                <AdminLayout
                    title="Create New Pack / Booster"
                    breadcrumbs={[
                        { label: 'Packs / Boosters', href: '/admin/packs' },
                        { label: 'Create' }
                    ]}
                >
                    <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-xl p-4 mb-6 max-w-4xl mx-auto">
                        <p className="text-fuchsia-800 font-medium">Set all required information to create a new pack.</p>
                    </div>
                    <PackForm
                        mode="create"
                        submitLabel="Create Pack"
                        onSubmit={this.handleSubmit}
                    />
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminCreatePack)
